export default __webpack_public_path__ + "static/media/9.e64d7acd.png";